/**
 * Pure H OS · Sprint 12 · Growth mocks — types + live views.
 * Payload now lives in MongoDB `pureh_*` collections.
 */
import { liveArray } from "../services/store";

export type SalesStage = "prospect" | "qualified" | "sample-sent" | "quote" | "won" | "lost";
export type SalesDeal = {
  id: string;
  customer: string;
  city: string;
  stage: SalesStage;
  valueEGP: number;
  probability: number;
  ownerName: string;
  productInterest: string[];
  lastTouchRelative: string;
  aiRecommendation: string;
};
export const SALES_DEALS: SalesDeal[] = liveArray<SalesDeal>("sales_deals");

export type LoyaltyTier = { key: string; name: string; minLtvEGP: number; benefits: string; members: number };
export const LOYALTY_TIERS: LoyaltyTier[] = liveArray<LoyaltyTier>("loyalty_tiers");

export type LoyaltyMember = { id: string; customer: string; tier: string; ltvEGP: number; joinedRelative: string; lastOrderRelative: string };
export const LOYALTY_MEMBERS: LoyaltyMember[] = liveArray<LoyaltyMember>("loyalty_members");

export type CohortRow = { cohort: string; customers: number; w1: number; w4: number; w8: number; w12: number };
export const COHORTS: CohortRow[] = liveArray<CohortRow>("cohorts");

// Attribution channels (renamed key in fixtures on collision with marketing channels).
export type Channel = { key: string; name: string; spendEGP: number; revenueEGP: number; ordersLast30: number; ROAS: number };
export const CHANNELS: Channel[] = liveArray<Channel>("channels");

export type GrowthKPI = { key: string; label: string; value: string; delta: number; trend: "up"|"down"|"flat"; hint?: string };
export const GROWTH_KPIS: GrowthKPI[] = liveArray<GrowthKPI>("growth_kpis");
